import moment from "moment";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const isEqualDate = (date1, date2) => {
  const d1 = date1 instanceof window.Date ? date1 : new Date(date1);
  const d2 = date2 instanceof window.Date ? date2 : new Date(date2);

  return (
    d1.getDate() === d2.getDate() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getFullYear() === d2.getFullYear()
  );
};

export const isEqualDay = (date1, date2) => {
  const d1 = date1 instanceof window.Date ? date1 : new Date(date1);
  const d2 = date2 instanceof window.Date ? date2 : new Date(date2);

  return d1.getDate() === d2.getDate();
};

/**
 * Convert date data string to local date object
 *
 * @param {string} date
 */
export const toLocalDate = date => {
  if (typeof date === "string") {
    if (date.includes("T")) {
      return new Date(date);
    } else {
      return new Date(date + " UTC");
    }
  } else if (date instanceof window.Date) {
    return date;
  }

  return undefined;
};

export const toMonthString = date => {
  date = toLocalDate(date);
  if (!date) return "";

  return `${date.getMonth() + 1}/${date.getFullYear()}`;
};

export const toMonthName = date => {
  date = toLocalDate(date);
  if (!date) return "";

  return monthNames[date.getMonth()];
};

export const toMonthYear = date => {
  date = toLocalDate(date);
  if (!date) return "";

  return toMonthName(date) + " " + date.getFullYear();
};

export const handleAcquired = acquired => {
  let date;
  if (
    typeof acquired === "object" &&
    acquired.first_acquired &&
    acquired.last_acquired
  ) {
    const firstAcquired = moment(acquired.first_acquired);
    const lastAcquired = moment(acquired.last_acquired);
    // whether it's monthly
    if (moment(firstAcquired).add(1, "months") >= lastAcquired) {
      date = firstAcquired.format("MMM YYYY");
    } else {
      date =
        firstAcquired.format("MMM") +
        " - " +
        lastAcquired.subtract(1, "months").format("MMM") +
        " " +
        lastAcquired.format("YYYY");
    }
  } else {
    date = moment(acquired).format("DD MMM YYYY");
  }

  return date;
};
